import 'babel-polyfill'
import { createApp } from './app'
import Vue from 'vue'
const { app, router, store } = createApp()
import loadingRegistry from '@/components/Loading'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { TooltipPlugin } from 'bootstrap-vue'
import 'element-ui/lib/theme-chalk/index.css';
import { Popover } from 'element-ui';
import registryAlert from '@/components/Alert'
import { isMobile } from '@/utilities/tools'
import './assets/common.less';

Vue.use(loadingRegistry)
Vue.use(registryAlert)
Vue.use(TooltipPlugin)
Vue.use(Popover)

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

// 客户端特定引导逻辑……
Vue.mixin({
  beforeMount () {
    const { asyncData } = this.$options
    if (asyncData) {
      // 将获取数据操作分配给 promise
      // 以便在组件中，我们可以在数据准备就绪后
      // 通过运行 `this.dataPromise.then(...)` 来执行其他任务
      this.dataPromise = asyncData({
        store: this.$store,
        route: this.$route,
        url: this.$route.path,
        component: this
      })
    }

    const seo = this.$store.state.page.meta
    if (seo && seo.title && seo.title.length > 0) {
      if (document) {
        document.title = seo.title
      }
    }
    
  }
})



// 这里假定 App.vue 模板中根元素具有 `id="app"`
router.onReady(() => {
  // mobile跳转
  if (isMobile()) {
      console.log("mobile")
      //  http://localhost:8080/Rccl.Partner/Partner/Active?activeToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJVc2VyTmFtZSI6IjEzNzY0MjkzMTc4MDMxMTEzNDQyODE0NiIsIlNlbmRUaW1lIjoiMjAyNS0wOS0xMVQxMToxNDoyMC4yMjE1NTIzKzA4OjAwIiwiUGFydG5lckVtYWlsIjoiYWhlQHJjY2xhcGFjLmNvbSJ9._Zzn7EHlBQbDxgxDF6ANTf9lMD6_Vff-OEdGs1sztpQ
      // 如果跳转到上面的地址 就弹出 alert 友好提示 用户，手机端没有这个页面
      let pathname = window.location.pathname;
      console.log(pathname,'pathname')
      if(pathname.indexOf("Rccl.Partner/Partner/Active") >= 0){
        alert("请在电脑端用浏览器打开。")
        return
      }
    location.href = `${process.env.VUE_APP_MOBILE_URL}${location.pathname}${location.search}` 
    return
  }


  // router.beforeResolve((to, from, next) => {
  //   const matched = router.getMatchedComponents(to)
  //   const prevMatched = router.getMatchedComponents(from)
    

  //   // 我们只关心非预渲染的组件
  //   // 所以我们对比它们，找出两个匹配列表的差异组件
  //   let diffed = false
  //   const activated = matched.filter((c, i) => {
  //     return diffed || (diffed = (prevMatched[i] !== c))
  //   })

  //   if (!activated.length) {
  //     return next()
  //   }

  //   // 这里如果有加载指示器 (loading indicator)，就触发

  //   Promise.all(activated.map(c => {
  //     if (c.asyncData) {
  //       return c.asyncData({ store, route: to })
  //     }
  //   })).then(() => {

  //     // 停止加载指示器(loading indicator)

  //     next()
  //   }).catch(next)
  // })
  app.$mount('#app')
})